import { render } from "./ShowPieceDeCaisse.vue?vue&type=template&id=d8cdece2"
import script from "./ShowPieceDeCaisse.vue?vue&type=script&lang=js"
export * from "./ShowPieceDeCaisse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__